import { Modal } from '@/components/Layout';
import React, { useEffect } from 'react';
import { useSchoolProposalList } from './schoolProposalList.hook';
import { Button, SelectDropDown, TextField } from '@/components/Common';
import { TextfieldType } from '@/components/Common/TextField/TextField.types';

const ValidateSchoolProposalForm = () => {
  const {
    isOpenSchoolProposalModal,
    openSchoolProposalModal,
    schoolType,
    schoolProposal,
    register,
    setValue,
    handleSubmit,
    onSubmit,
    onRefuseProposal,
    isPending,
    mode,
  } = useSchoolProposalList();

  useEffect(() => {
    setValue('school', schoolProposal?.school);
  }, [schoolProposal, setValue]);

  const renderValidateForm = () => (
    <form className="flex flex-col gap-1" onSubmit={handleSubmit(onSubmit)}>
      <h3 className="text-white text-xl font-bold text-center mb-3">
        Valider une école
      </h3>
      <SelectDropDown
        options={schoolType || []}
        placeholder="Publique ou Privée"
        initialSelectedOptions={{
          _id: 1,
          name: schoolProposal?.privateOrPublic,
        }}
        name="schooltype"
        setValue={setValue}
      />
      <TextField
        textFieldType={TextfieldType.INPUT}
        placeholder="Nom de l'école"
        inputStyle={{ background: '#232323' }}
        name="school"
        register={register('school')}
      />
      <Button
        title={isPending ? 'Validation...' : 'Ajouter'}
        className="mt-3"
        type="submit"
      />
    </form>
  );

  const renderRefuseForm = () => (
    <div className="flex flex-col gap-1">
      <h3 className="text-white text-xl font-bold text-center mb-2">
        Refuser l'école
      </h3>
      <p className="text-center text-gray-400 mx-auto my-0">
        Êtes-vous sûr de vouloir refuser{' '}
        <span className="block">cette requête ?</span>
      </p>
      <div className="flex justify-between items-center gap-6  mt-4">
        <Button
          onClick={openSchoolProposalModal}
          title="Annuler"
          className="!bg-completed hover:!outline-completed hover:!text-completed
                hover:!bg-hoverColor  text-white !px-16"
        />
        <Button
          className="!px-16"
          title={isPending ? 'Confirmation...' : 'Refuser'}
          onClick={onRefuseProposal}
        />
      </div>
    </div>
  );

  return (
    <Modal
      isOpen={isOpenSchoolProposalModal}
      onClose={openSchoolProposalModal}
      modalStyle="bg-[#2A2A2A] min-w-[23.4375rem]"
      headerStyle="bg-[#2A2A2A]"
    >
      {mode === 'validate' ? renderValidateForm() : renderRefuseForm()}
    </Modal>
  );
};

export default ValidateSchoolProposalForm;
